module.exports = __webpack_public_path__ + "0311b37e8e8d0ce394f042eb427b6e10.svg";